module.exports = __webpack_public_path__ + "resources/img/img_mazebolt2.fe517bb515a037055d7324b60e732dc0.png";